import { Delete, Edit } from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Alert from "components/alert";
import TableSkeleton from "components/skeletons/TableSkeleton";
import TablePagination from "components/tablePagination";
import { deleteExpense } from "features/expense/api/expense";
import useApi from "hooks/useApi";
import moment from "moment";
import { useState } from "react";
import { toast } from "react-toastify";

const ExpenseTable = ({
  loading,
  allExpense,
  setAllExpense,
  setCurrExpense,
  setAddExpense,
  pagination,
  setPagination,
  setReload,
}) => {
  const rows = allExpense;
  const columns = [
    { id: "expense_number", label: "Expense No." },
    { id: "expense_category_name", label: "Category" },
    { id: "payment_method_name", label: "Payment Method" },
    { id: "name", label: "Expense Name" },
    { id: "reference_name", label: "Reference" },
    { id: "created_at", label: "Created At" },
    { id: "total", label: "Total", align: "right" },
    { id: "action", label: "Actions", minWidth: 70, align: "center" },
  ];
  const { fetchData } = useApi();

  const [openAlert, setOpenAlert] = useState(false);

  const handleDelete = async (id) => {
    setOpenAlert(id);
  };

  const handleDeleteConfirm = async () => {
    const result = await fetchData(deleteExpense(openAlert));
    if (result.success) {
      setAllExpense(
        allExpense.filter((admission) => admission.id !== openAlert)
      );
    } else {
      toast.error(result.message);
    }
    setOpenAlert(false);
  };

  const handleEditBtn = (value) => {
    setCurrExpense(value);
    setAddExpense(true);
  };

  return (
    <>
      {openAlert && (
        <Alert
          open={openAlert}
          handleClose={setOpenAlert}
          title="Delete Expense"
          desc={
            <Box>
              Are you sure you want to delete? This will delete this Expense
              permanently. <strong>You can't undo this action</strong>
            </Box>
          }
          buttons={
            <>
              <Button onClick={() => setOpenAlert(false)}>No, keep it</Button>
              <Button variant="solid" onClick={handleDeleteConfirm}>
                Yes, delete it
              </Button>
            </>
          }
        />
      )}
      {!loading ? (
        <TableContainer
          sx={{ height: "calc(100vh - 245px)", overflowX: "auto" }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map((row) => {
                return (
                  <TableRow hover role="checkbox" key={row.id}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number" ? (
                            column.format(value)
                          ) : column.id === "expense_date" ? (
                            moment(value).format("ll")
                          ) : column.id === "created_at" ? (
                            moment(value).format("ll")
                          ) : column.id === "tax" ? (
                            <Typography color="#2fb42f" variant="body2">
                              {"+ " + row.symbol + value}
                            </Typography>
                          ) : column.id === "discount" ? (
                            <Typography color="#ff3535" variant="body2">
                              {"- " + row.symbol + value}
                            </Typography>
                          ) : column.id === "total" ? (
                            <Typography color="#7171ff" variant="body2">
                              {row.symbol}
                              {value + row.tax - row.discount}
                            </Typography>
                          ) : column.id === "subtotal" ? (
                            <Typography variant="body2">
                              {row.symbol + value}
                            </Typography>
                          ) : column.id === "action" ? (
                            <Box
                              sx={{
                                display: "flex",
                                gap: "10px",
                                justifyContent: "center",
                              }}
                            >
                              <IconButton onClick={() => handleEditBtn(row)}>
                                <Edit />
                              </IconButton>
                              <IconButton onClick={() => handleDelete(row.id)}>
                                <Delete />
                              </IconButton>
                            </Box>
                          ) : (
                            value
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <TableSkeleton columns={columns} tableHeight="calc(100vh - 265px)" />
      )}
      <TablePagination
        span={columns?.length}
        setReload={setReload}
        pagination={pagination}
        setPagination={setPagination}
      />
    </>
  );
};

export default ExpenseTable;
